;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Controller = APP.module('Controller');
	var Router     = APP.module('Router');
	var Model      = APP.module('Model');
	var View       = APP.module('View');
	var Layout     = APP.module('Layout');
	var Collection = APP.module('Collection');

	Controller.Help = function(){

	};

	// Variable to check if first time in Help section
	var help_started = false;

	_.extend(Controller.Help.prototype, {
		start: function(){

			this.sidebar = new Model.SidebarBuilder();

			var sidebar = new Layout.Sidebar({
				widgets_list: this.sidebar.get('widgets'),
				widgets_options: {
					side_menu_items: this.sidebar.get('menuItems')
				}
			});

			this.view = new Layout.HelpLeftSidebarLayout();
			this.layout = new Layout.HelpLayout();

			APP.main.show(this.view);

			this.view.aside.show( sidebar );
			this.view.main.show( this.layout );

			help_started = true;

		},

		initLayout: function () {
			// Init layout only once || Init when no layout || Init when layout has been destroyed
			if ( !help_started || !this.layout || this.layout.isDestroyed) {
				this.start();
			}
		},

		terms: function () {
			//this.initLayout();
			this.start();
			var view = new View.HelpTerms({
				model: new Model.StaticContent({
					filename_part: 'terms_and_conditions'
				})
			});
			this.layout.terms.show( view );
		},

		faqs: function () {
			//this.initLayout();
			this.start();
			var view = new View.HelpFaqs({
				model: new Model.StaticContent({
					filename_part: 'faq'
				})
			});
			this.layout.faqs.show( view );
		},

		prizes: function () {
			//this.initLayout();
			this.start();
			var view = new View.HelpPrizes({
				model: new Model.StaticContent({
					filename_part: 'prizes'
				})
			});
			this.layout.prizes.show( view );
		},

		rules: function () {
			//this.initLayout();
			this.start();
			var view = new View.HelpGameRules({
				model: new Model.StaticContent({
					filename_part: 'game_rules'
				})
			});
			this.layout.rules.show( view );
		},

		guidelines: function () {
			//this.initLayout();
			this.start();
			var view = new View.HelpGameGuidelines({
				model: new Model.StaticContent({
					filename_part: 'game_guidelines'
				})
			});
			this.layout.rules.show( view );
		}
	});

	APP.on('start', function() {
		var controller = new Controller.Help();
		var router = new Router.Help({ controller: controller });
	});

}(window, APP, Backbone, Marionette, $, _));